// @ts-check
import { connect } from "react-redux";
import { profileSelector, profileActions } from "./profile-reducer";

export const mapStateToProps = function (state) {
    return {
        userInfo: profileSelector.userInfo(state),
        loggedIn: profileSelector.loggedIn(state),
        loginUrl: profileSelector.loginUrl(state),
        logoutUrl: profileSelector.logoutUrl(state),
        profileLinks: profileSelector.profileLinks(state),
        userName: profileSelector.userName(state),
        userCreatePending: profileSelector.userCreatePending(state),
        loginRedirecting: profileSelector.loginRedirecting(state),
        createLoginContent: profileSelector.createLoginContent(state),
        createProfileUrl: profileSelector.createProfileUrl(state),
        createProfileUniLoginUrl: profileSelector.createProfileUniLoginUrl(state),
        uniPromptContent: profileSelector.uniPromptContent(state),
        isUniLoggedInOnly: profileSelector.isUniLoggedInOnly(state)
    };
};

export const mapDispatchToProps = function (dispatch) {
    return {
        userLoggedIn: () => dispatch(profileActions.userLoggedIn()),
        userLogin: () => dispatch(profileActions.userLogin()),
        unicConnect: () => dispatch(profileActions.unicConnect()),
        userLogout: () => dispatch(profileActions.userLogout()),
        userCreateSubmit: (userinfo, resolve, reject, apiUrl) =>
            dispatch(profileActions.userCreateSubmit({ userinfo, resolve, reject, apiUrl })),
        getNewsletterProfile: (email, resolve, reject, apiUrl) =>
            dispatch(profileActions.getNewsletterProfile({ email, resolve, reject, apiUrl }))
    };
};

export function profileComposer(Component) {
    return connect(mapStateToProps, mapDispatchToProps)(Component);
}
